export default {
    Market: 'Pazar',
    Rates: 'Oranlar',
    AddNew: '+ Yeni ekle',
    ThisWeek: 'Bu hafta',
    PlusAddNew: 'Yeni Coin ekle'
}